export const createTask = /* GraphQL */ `
  mutation createTask($input: CreateTaskInput!) {
  createTask(input: $input) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const createTaskListUnit = /* GraphQL */ `
  mutation createTaskListUnit($input: CreateTaskListUnitInput!) {
  createTaskListUnit(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const createTaskReport = /* GraphQL */ `
  mutation createTaskReport($input: CreateTaskReportInput!) {
  createTaskReport(input: $input) {
      comment
      commentImages
      completedAt
      completedBy
      createdAt
      createdBy
      id
      images
      logicalDayStart
      status
      taskId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const deleteTask = /* GraphQL */ `
  mutation deleteTask($input: DeleteTaskInput!) {
  deleteTask(input: $input) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const deleteTaskList = /* GraphQL */ `
  mutation deleteTaskList($input: DeleteTaskListInput!) {
  deleteTaskList(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const deleteTaskListUnit = /* GraphQL */ `
  mutation deleteTaskListUnit($input: DeleteTaskListUnitInput!) {
  deleteTaskListUnit(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const deleteTaskReport = /* GraphQL */ `
  mutation deleteTaskReport($input: DeleteTaskReportInput!) {
  deleteTaskReport(input: $input) {
      comment
      commentImages
      completedAt
      completedBy
      createdAt
      createdBy
      id
      images
      logicalDayStart
      status
      taskId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const duplicateTaskList = /* GraphQL */ `
  mutation duplicateTaskList($input: DuplicateTaskListInput!) {
  duplicateTaskList(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const duplicateTaskListUnit = /* GraphQL */ `
  mutation duplicateTaskListUnit($input: DuplicateTaskListUnitInput!) {
  duplicateTaskListUnit(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const moveTaskInTaskListUnit = /* GraphQL */ `
  mutation moveTaskInTaskListUnit($input: MoveTaskInTaskListUnitInput!) {
  moveTaskInTaskListUnit(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on TaskListUnit {
        avatarPath
        createdAt
        createdBy
        description
        id
        isArchived
        locationId
        logicalDayShift
        name
        ownerId
        taskLists
        taskListsOrder
        timezone
        updatedAt
        updatedBy
        version
        workspaceId
      }
  }
}
`;

export const resolveIssueWithCorrectiveTask = /* GraphQL */ `
  mutation resolveIssueWithCorrectiveTask($input: ResolveIssueWithCorrectiveTaskInput!) {
  resolveIssueWithCorrectiveTask(input: $input) {
      archivedAt
      auditRunId
      correctiveTaskId
      createdAt
      createdBy
      deletedAt
      description
      dismissComment
      id
      images
      lastSignalAt
      locationId
      overdueCount
      ownerId
      reopenedAt
      reopenedBy
      reportedBy
      resolutionNote
      resolutionType
      resolvedAt
      resolvedBy
      source
      sourceRef
      status
      taskId
      taskListUnitId
      taskReportId
      title
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const restoreTask = /* GraphQL */ `
  mutation restoreTask($input: RestoreTaskInput!) {
  restoreTask(input: $input) {
      config
      correctiveReason
      createdAt
      createdBy
      description
      id
      images
      isArchived
      isCorrective
      lateCloseEnabled
      lateCloseUntilDays
      linkedIssueId
      name
      relatedPage
      scheduleRule
      taskListId
      taskListUnitId
      updatedAt
      updatedBy
      version
  }
}
`;

export const restoreTaskList = /* GraphQL */ `
  mutation restoreTaskList($input: RestoreTaskListInput!) {
  restoreTaskList(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const restoreTaskListUnit = /* GraphQL */ `
  mutation restoreTaskListUnit($input: RestoreTaskListUnitInput!) {
  restoreTaskListUnit(input: $input) {
      avatarPath
      createdAt
      createdBy
      description
      id
      isArchived
      locationId
      logicalDayShift
      name
      ownerId
      taskLists
      taskListsOrder
      timezone
      updatedAt
      updatedBy
      version
      workspaceId
  }
}
`;

export const updateTask = /* GraphQL */ `
  mutation updateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on Task {
        config
        correctiveReason
        createdAt
        createdBy
        description
        id
        images
        isArchived
        isCorrective
        lateCloseEnabled
        lateCloseUntilDays
        linkedIssueId
        name
        relatedPage
        scheduleRule
        taskListId
        taskListUnitId
        updatedAt
        updatedBy
        version
      }
  }
}
`;

export const updateTaskListUnit = /* GraphQL */ `
  mutation updateTaskListUnit($input: UpdateTaskListUnitInput!) {
  updateTaskListUnit(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on TaskListUnit {
        avatarPath
        createdAt
        createdBy
        description
        id
        isArchived
        locationId
        logicalDayShift
        name
        ownerId
        taskLists
        taskListsOrder
        timezone
        updatedAt
        updatedBy
        version
        workspaceId
      }
  }
}
`;

export const updateTaskReport = /* GraphQL */ `
  mutation updateTaskReport($input: UpdateTaskReportInput!) {
  updateTaskReport(input: $input) {
      ... on ConflictError {
        actualVersion
        conflictType
        currentState
        entityId
        entityType
        expectedVersion
        metadata
      }
      ... on TaskReport {
        comment
        commentImages
        completedAt
        completedBy
        createdAt
        createdBy
        id
        images
        logicalDayStart
        status
        taskId
        taskListUnitId
        updatedAt
        updatedBy
        version
      }
  }
}
`;
